<div class="chatbot-fullscreen-page">
    <avioblue-chatbot domain="camo" initialView="fullscreen" [showViewPicker]="false" [showAgentPicker]="false"></avioblue-chatbot>
</div>
